import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { getTableSectionsItems } from "../../../../../components/tables/sectionTable/sectionTableHelper";
import { TableSectionActionsProps } from "../../../../../components/tables/sectionTable/sectionTable.interface";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  RecallClientActionsDataInterface,
  RecallClientBatchAction,
} from "../../../../../redux/interfaces/recall.interface";
import { openRecallClientBatch } from "../../../../../redux/reducer/recall.reducer";
import {
  canGenerateRecallDocument,
  canRequestRecallAwb,
} from "../recallClientActionsHelper";

function RecallSectionActions({ section, crudData }: TableSectionActionsProps) {
  const dispatch = useAppDispatch();
  const entry = useAppSelector((state) => state.recall.entry);
  const isBatchLoading = useAppSelector(
    (state) => state.recall.clientBatch.isLoading,
  );
  const hasPendingClientActions = useAppSelector(
    (state) => state.recall.pendingClientActionIds.length > 0,
  );
  const awbAttemptedClientIds = useAppSelector(
    (state) => state.recall.awbAttemptedClientIds,
  );
  if (crudData?.type !== "route") return null;

  const clients = Array.from(
    new Map(
      getTableSectionsItems([section]).map((row) => {
        const client: RecallClientActionsDataInterface = row.crudData;
        return [client.clientPlId, client] as const;
      }),
    ).values(),
  );
  const documentClients = clients.filter(canGenerateRecallDocument);
  const awbClients = clients.filter((client) =>
    canRequestRecallAwb(client, awbAttemptedClientIds),
  );
  const busyReason = entry.isLoading
    ? "Se incarca datele retragerii."
    : entry.isError
    ? "Reincarca datele retragerii inainte de a continua."
    : isBatchLoading || hasPendingClientActions
    ? "Asteapta finalizarea actiunii in curs pentru farmacii."
    : "";
  const isBusy = Boolean(busyReason);

  const handleOpen = (action: RecallClientBatchAction) => {
    if (isBusy || !entry.data) return;
    const eligibleClients =
      action === "documents" ? documentClients : awbClients;
    if (!eligibleClients.length) return;
    dispatch(
      openRecallClientBatch({
        idCampaign: entry.data.idCampaign,
        title: section.title,
        action,
        clients: eligibleClients.map(({ clientPlId, pharmacyName }) => ({
          clientPlId,
          pharmacyName,
        })),
        excludedCount: clients.length - eligibleClients.length,
      }),
    );
  };

  return (
    <ActionMenu
      title={section.title}
      ariaLabel={`Actiuni pentru ruta ${crudData.routeName ?? section.id}`}
      minItemsForMenu={2}
      items={[
        {
          id: "generate-documents",
          label: "Genereaza documente",
          icon: "GENERATE_DOCUMENT",
          disabled: isBusy || !documentClients.length,
          tooltip:
            busyReason ||
            (documentClients.length
              ? `Deschide lista farmaciilor eligibile din grup (${documentClients.length}) pentru generarea documentelor lipsa, dupa confirmare.`
              : "Nu exista documente de generat in acest grup"),
          onClick: () => handleOpen("documents"),
        },
        {
          id: "request-awb",
          label: "Solicita AWB",
          icon: "REQUEST_AWB",
          disabled: isBusy || !awbClients.length,
          tooltip:
            busyReason ||
            (awbClients.length
              ? `Deschide lista farmaciilor eligibile din grup (${awbClients.length}) pentru solicitarea AWB-urilor in TMS, dupa confirmare.`
              : "Nu exista farmacii eligibile pentru solicitarea AWB in acest grup."),
          onClick: () => handleOpen("awb"),
        },
      ]}
    />
  );
}

export default RecallSectionActions;
